import {EventSpecifier} from "./eventspecifier.mjs";


export class EventManager{
    constructor(){
        var _eventSpecifierMap = new Map();
        var _eventRegisteredArray = [];
        

        Object.defineProperty(this,'eventSpecifierMap',{
            get : function(){ return _eventSpecifierMap }
        });

        Object.defineProperty(this,'eventRegisteredArray',{
            get : function(){ return _eventRegisteredArray }
        })
    }

    // =======
    // private 
    // -------
    getEventSpecifierMap(){ return this.eventSpecifierMap }

    getEventRegisteredArray(){ return this.eventRegisteredArray }

    addEventSpecifier(es){
        var map = this.getEventSpecifierMap();
        var eventSpecifiers = map.get(es.getType());
        if (eventSpecifiers){
            eventSpecifiers.push(es);
        } else {
            map.set(es.getType(),[es]);
        }
    }

    /* added 02-06 */
    removeEventSpecifier(eventType, eventHandler){
        var map = this.getEventSpecifierMap();
        var eventSpecifiers = map.get(eventType);
        if (eventSpecifiers.length){
            for (var i = 0; i < eventSpecifiers.length ; i ++){
                var handler = eventSpecifiers[i].handler;
                var type = eventSpecifiers[i].type;
                if ((type === eventType) && ( handler === eventHandler)) eventSpecifiers.splice(i,1);
            }
            if (!eventSpecifiers.length) map.delete(eventType);
            else map.set(eventType, eventSpecifiers);
        }
    }
    
    registerEventType(eventType){
        this.getEventRegisteredArray().push(eventType);
    }

    isRegisteredEventType(eventType){ return this.getEventRegisteredArray().includes(eventType) }

    updateListeners(domNode){
        var map = this.getEventSpecifierMap();
        for (var eventType of map.keys()){
            if (!this.isRegisteredEventType(eventType)){
                domNode.addEventListener(eventType, this.onComponentEventRouter.bind(this));
                this.registerEventType(eventType);
            } 
        }
        
    }

    onComponentEventRouter(event){
        var map = this.getEventSpecifierMap();
        var eventSpecifiers = map.get(event.type);
        if (eventSpecifiers){
            eventSpecifiers.forEach((eventSpecifier)=>{
                if (eventSpecifier) eventSpecifier.run(event);
            });
        }
    }

    // ==========
    // API (public)
    // ----------
    on(eventType, testTarget, handler, bubbleup){
        var eventSpecifier = new EventSpecifier(eventType, testTarget, handler, bubbleup);
        this.addEventSpecifier(eventSpecifier);
    }
}


